/** 解析 CSS unicode-range 单 token → [start, end] */
export function parseUnicodeRangeToken(token: string): [number, number] | null {
  const trimmed = token.trim();
  if (!trimmed.startsWith('U+') && !trimmed.startsWith('u+')) return null;
  const raw = trimmed.slice(2);
  if (raw.includes('-')) {
    const [a, b] = raw.split('-');
    return [parseInt(a, 16), parseInt(b, 16)];
  }
  if (raw.includes('?')) {
    return [
      parseInt(raw.replace(/\?/g, '0'), 16),
      parseInt(raw.replace(/\?/g, 'F'), 16),
    ];
  }
  const value = parseInt(raw, 16);
  return Number.isNaN(value) ? null : [value, value];
}

/** 解析 unicode-range 声明为区间列表 */
export function parseUnicodeRange(value: string): Array<[number, number]> {
  return value
    .split(',')
    .map(parseUnicodeRangeToken)
    .filter((range): range is [number, number] => range !== null);
}

/** 码点是否落在 unicode-range 内；无 range 表示整字体 */
export function codepointInUnicodeRange(cp: number, unicodeRange?: string): boolean {
  if (!unicodeRange) return true;
  for (const [lo, hi] of parseUnicodeRange(unicodeRange)) {
    if (cp >= lo && cp <= hi) return true;
  }
  return false;
}

/** 从文本提取唯一码点（已去重、排序） */
export function uniqueCodepointsFromText(text: string): number[] {
  const seen = new Set<number>();
  for (const char of text) {
    seen.add(char.codePointAt(0)!);
  }
  return [...seen].sort((a, b) => a - b);
}
